export const fmtMoney = (amount, currency = "UGX") =>
  `${currency} ${Number(amount || 0).toLocaleString()}`;

export const fmtDateTime = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString(undefined, {
      weekday: "short",
      day: "numeric",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "";
  }
};

export const fmtDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      weekday: "long",
      day: "numeric",
      month: "long",
    });
  } catch {
    return "";
  }
};

export const fmtTime = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" });
  } catch {
    return "";
  }
};

// The human serial, formatted to be READ ALOUD.
//
// The serial stopped being decoration the moment an admit-by-serial path went
// into the backend: it is now the real fallback when a QR will not scan — a
// cracked screen, a flat battery, a printed ticket. `makeSerial` mints "LSK-"
// plus 12 uppercase hex characters, and the server's own comment calls that
// "short enough to read aloud across a foyer in three groups of four", so that
// is exactly how it is grouped here. `normalizeSerial` on the terminal strips
// the spaces and the dash again, so the grouping costs nothing.
export const formatSerial = (serial) => {
  const raw = String(serial || "")
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");
  if (!raw) return "";
  const body = raw.startsWith("LSK") ? raw.slice(3) : raw;
  if (!body) return "";
  const grouped = body.match(/.{1,4}/g) || [body];
  return `LSK-${grouped.join(" ")}`;
};

export const minTicketPrice = (showing) => {
  const ts = showing?.ticketTypes || [];
  if (!ts.length) return null;
  return Math.min(...ts.map((t) => Number(t.price || 0)));
};

// EventShowing stores presentation.format/dimension UPPERCASE (the schema
// forces it, and the seat-class matching depends on that stored casing), so the
// customer read a shouted "STANDARD \u00b7 2D" where every cinema in the market
// writes "Standard \u00b7 2D". Case the FORMAT for display only; the dimension
// (2D/3D/4DX) and free-text sound are left exactly as entered.
const KEEP_UPPER = new Set(["IMAX", "VIP", "4DX", "3D", "2D", "MX4D", "SCREENX", "VMAX"]);
export const experienceFormat = (value) =>
  String(value || "")
    .split(" ")
    .filter(Boolean)
    .map((w) => (KEEP_UPPER.has(w.toUpperCase()) ? w.toUpperCase() : w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()))
    .join(" ");

// "Standard \u00b7 2D", "Max \u00b7 2D \u00b7 Dolby Atmos" \u2014 the row header customers group by.
export const experienceLabel = (showing) =>
  [experienceFormat(showing?.presentation?.format), showing?.presentation?.dimension, showing?.presentation?.sound]
    .filter(Boolean)
    .join(" \u00b7 ");
